import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfileGuard } from '@guards/profile/profile.guard';
import {
  ClientResolver,
  CoursesResolver,
  ItineraryResolver,
  LocalesResolver,
  PartnerClientResolver
} from 'core/resolvers';
import { ItinerariesComponent } from './itineraries/itineraries.component';
import { ItineraryDetailComponent } from './itinerary-detail/itinerary-detail.component';
import { ItineraryCreateComponent } from './itinerary-create/itinerary-create.component';

const itinerariesRoutes: Routes = [
  {
    path: 'itineraries',
    title: 'parentItineraries',
    resolve: {
      locales: LocalesResolver
    },
    children: [
      {
        path: '',
        title: 'itineraries',
        component: ItinerariesComponent,
        canActivate: [ProfileGuard],
        data: { action: 'training.itineraries.list', refreshCoursesCache: true },
        resolve: {
          client: ClientResolver,
          courses: CoursesResolver
        }
      },
      {
        path: 'new',
        title: 'newItinerary',
        component: ItineraryCreateComponent,
        canActivate: [ProfileGuard],
        data: { action: 'training.itineraries.create' },
        resolve: {
          client: ClientResolver,
          courses: CoursesResolver,
          partnerClient: PartnerClientResolver
        }
      },
      {
        path: ':itineraryId',
        title: 'itineraryIdDetail',
        component: ItineraryDetailComponent,
        canActivate: [ProfileGuard],
        data: { action: 'training.itineraries.detail', preloader: 'secondary' },
        resolve: {
          client: ClientResolver,
          courses: CoursesResolver,
          partnerClient: PartnerClientResolver,
          itinerary: ItineraryResolver
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(itinerariesRoutes)],
  exports: [RouterModule]
})
export class ItinerariesRoutingModule {}
